import { MapPin, Navigation } from "lucide-react";

const LOCATIONS = [
  {
    id: "bowness",
    name: "Bowness Location",
    address: "2 Bowbank Crescent NW",
    city: "Calgary, AB",
    note: "Convenient NW Calgary location for clients in Bowness & surrounding communities.",
    mapsQuery: "2 Bowbank Crescent NW, Calgary, AB",
    embedSrc:
      "https://www.google.com/maps?q=2+Bowbank+Crescent+NW%2C+Calgary%2C+AB&output=embed",
  },
];

export default function Locations() {
  return (
    <section
      id="locations"
      data-testid="locations-section"
      className="relative py-20 sm:py-28 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-blue-800 mb-4">
            Location
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]">
            Find me close to home.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            KneadRelief is based in NW Calgary — book online any time and drop by
            when it's convenient for you.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 max-w-2xl mx-auto">
          {LOCATIONS.map((loc) => (
            <div
              key={loc.id}
              data-testid={`location-card-${loc.id}`}
              className="group rounded-3xl border border-slate-100 bg-slate-50/60 overflow-hidden hover:shadow-xl hover:shadow-blue-900/5 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative h-[280px] sm:h-[320px] overflow-hidden">
                <iframe
                  title={`${loc.name} map`}
                  data-testid={`location-map-${loc.id}`}
                  src={loc.embedSrc}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-full"
                />
              </div>

              <div className="p-6 sm:p-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-blue-100 flex items-center justify-center shrink-0">
                    <MapPin size={22} strokeWidth={1.6} className="text-blue-800" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-xs uppercase tracking-[0.18em] font-semibold text-blue-800">
                      {loc.name}
                    </div>
                    <div className="mt-1 font-display font-bold text-xl text-slate-900 leading-tight">
                      {loc.address}
                    </div>
                    <div className="text-sm text-slate-500 mt-0.5">{loc.city}</div>
                    <p className="text-sm text-slate-600 mt-3 leading-relaxed">{loc.note}</p>

                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc.mapsQuery)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`location-directions-${loc.id}`}
                      className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-blue-800 hover:text-blue-900 transition-colors"
                    >
                      <Navigation size={15} strokeWidth={2} />
                      Get directions
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
